module.exports = __webpack_public_path__ + "img/b2-1.42507312.png";